<template>
  <div class="flex">
    <div class="justify-center py-6 px-4 sm:px-6 lg:px-8 md:w-1/2 mt-4 border mx-auto bg-white shadow-sm">
      <div class="bg-blue-100 mb-6 border-l-4 border-blue-500  text-blue-900 px-4 py-3" role="alert">
        <div class="flex">
          <div class="py-1">
            <feather type="info" class="fill-current h-6 w-6 text-blue-500 mr-4"></feather>
          </div>
          <div>
            <p class="font-bold">To get started, create or select an organization.</p>
            <p class="text-sm">All activities are managed under an organization. You can
              have more than one.</p>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <div class="py-2">
          Current organizations
        </div>
        <router-link :to="{name: 'home', params:{orgId: org.id}}" v-for="org in organizations" :key="org.id"
                     class="block hover:bg-gray-200 py-1 border-b">
          <div class="">{{ org.name }}</div>
          <div>
            <small>{{ org.address }}</small>
          </div>
        </router-link>
      </div>
      <div class="pt-2 font-bold">
        Create another organization
      </div>
      <create-organization :breadcrumb="false"/>
    </div>
  </div>
</template>

<script>
import CreateOrganization from "@/modules/organization/CreateOrganization";

export default {
  name: "SelectOrganization",
  components: {CreateOrganization},
  data() {
    return {
      organizations: []
    }
  },
  mounted() {
    this.getMyOrganizations()
  },
  methods: {
    getMyOrganizations: function () {
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations')
          .then((result) => {
            this.organizations = result.data.data.organizations;
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push("/logout");
            }
          });
    }
  }
}
</script>

<style scoped>

</style>